module.exports = function (settingsService, trolleyService, loginService, shopperService, savedListsService, moveFocus, $timeout, $rootScope, $sanitize) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            settingsService.getSettingValue('OneSite', 'EnableSaveListFromCollectionZone').then(function (value) {
                scope.showSaveTrolleyAsList = value;
            });

            scope.showSaveListOption = function () {
                //check if the the user is a guest
                if (shopperService.currentUser.isGuest) {
                    $rootScope.$broadcast('save-trolley-as-list-login', { message: 'Please login to save your trolley as a list.' });
                    scope.promptedForLogin = true;
                    scope.showSaveListInput = false;
                } else {
                    if (!scope.showSaveListInput) {
                        scope.showSaveListInput = true;
                    } else {
                        scope.showSaveListInput = false;
                        scope.clearNewListEntry();
                    }
                }
            };

            scope.$on('login:success', function () {
                if (scope.promptedForLogin) {
                    scope.promptedForLogin = false;
                    scope.showTickMark = false;
                    scope.showSaveListInput = true;
                }
            });

            scope.clearNewListEntry = function () {
                scope.newListSave.listName = '';
                scope.error = undefined;
                scope.errorMessage = undefined;
                scope.newListSaveClicked = false;

                moveFocus('#save-trolley-list');
            };

            scope.afterSavingTheList = function () {
                scope.savedListName = scope.newListSave.listName;
                scope.error = undefined;
                scope.errorMessage = undefined;
                scope.newListSaveClicked = false;

                moveFocus('#successful-tick');
                const message = `Your trolley is saved successfully as a list called ${scope.newListSave.listName}`;
                scope.updateStatusMessage(message);
            };

            scope.updateStatusMessage = function (message) {
                scope.statusMessage = message;
            };

            scope.handelTabBack = function (event) {
                const keyCode = ('which' in event) ? event.which : event.keyCode;
                if (event.shiftKey && keyCode === 9) {
                    event.preventDefault();
                    moveFocus('._saveTrolleyAsListLink');
                }
            };

            scope.saveTrolleyAsList = function () {
                if (scope.newListSave.listName && scope.newListSave.listName.length > 0) {
                    scope.newListSaveClicked = true;
                    scope.newListSave.listName = $sanitize(scope.newListSave.listName).trim();
                    trolleyService.saveTrolleyAsList(scope.newListSave.listName).then(function (response) {
                        if (response.Success) {
                            savedListsService.invalidate();
                            $rootScope.$broadcast('saveTrolleyAsList:ListSuccessfull');
                            scope.showTickMark = true;
                            scope.afterSavingTheList();
                            $timeout(function () {
                                scope.showTickMark = false;
                                if (scope.savedListName === scope.newListSave.listName) {
                                    scope.savedListName = '';
                                    scope.newListSave.listName = '';
                                    scope.showSaveListInput = false;
                                    moveFocus('._saveTrolleyAsListLink');
                                }
                            }, 5000);
                        } else {
                            scope.error = true;
                            scope.errorMessage = response.Message;
                            scope.newListSaveClicked = false;

                            moveFocus('#error-message');
                        }
                    });
                }
            };
        },
        template: require('./save-trolley-as-list.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/save-trolley-as-list-directive.js
 **/